import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { Base64 } from 'js-base64';
import { compact } from 'lodash-es';
import { LAST_USER_INTERACTION_LOCAL_STORAGE_KEY } from '~/infra/session-storage';
import { extractClaimsFromToken } from '~/infra/utils';
export const NATIVE_AUTH_TOKEN_LOCAL_STORAGE_KEY = 'anchor.native.authToken.v1';
export class RealCookiesManager {
    getCookie() {
        return document.cookie;
    }
    setCookie(key, value) {
        let opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        document.cookie = compact([
            "".concat(key, "=").concat(value),
            opts.expires && "expires=".concat(opts.expires.toUTCString()),
            'path=/',
            this.authDomain && "domain=".concat(this.authDomain)
        ]).join('; ');
    }
    setAuthTokenForNative(value) {
        let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.localStorage.setItem(NATIVE_AUTH_TOKEN_LOCAL_STORAGE_KEY, value);
        this.nativeAuthTokenStore.persist(value);
        if (!opts.skipBiometricMarkerClear) {
            this.biometric.onAuthTokenWritten();
        }
    }
    clearAuthToken() {
        this.setCookie('AuthToken', '', {
            expires: new Date(0)
        });
        this.localStorage.removeItem(NATIVE_AUTH_TOKEN_LOCAL_STORAGE_KEY);
        this.localStorage.removeItem(LAST_USER_INTERACTION_LOCAL_STORAGE_KEY);
        this.nativeAuthTokenStore.clear();
        this.biometric.onAuthTokenWritten();
    }
    getCookieByName(name) {
        const cookieMap = this.getCookieMap();
        return cookieMap[name] || null;
    }
    getDecodedCookieByName(name) {
        const originalCookie = this.getCookieByName(name);
        if (!originalCookie) {
            return null;
        }
        return Base64.decode(originalCookie);
    }
    getUserEmailFromUserDetailsCookie() {
        const decodedCookie = this.getDecodedCookieByName('last_login_user_details');
        if (!decodedCookie || !decodedCookie.includes('email')) {
            return null;
        }
        const userDetails = JSON.parse(decodedCookie);
        return userDetails.email;
    }
    getHasVendorAccountFromUserDetailsCookie() {
        const decodedCookie = this.getDecodedCookieByName('last_login_user_details');
        if (!decodedCookie || !decodedCookie.includes('hasVendorAccount')) {
            return null;
        }
        const userDetails = JSON.parse(decodedCookie);
        return userDetails.hasVendorAccount;
    }
    getAuthToken() {
        const cookieMap = this.getCookieMap();
        return cookieMap.AuthToken || this.localStorage.getItem(NATIVE_AUTH_TOKEN_LOCAL_STORAGE_KEY) || null;
    }
    getClaims() {
        return extractClaimsFromToken(this.getAuthToken());
    }
    trySignalAuthTokenChange() {
        var _this_getClaims;
        const authToken = this.getAuthToken();
        const prevAuthToken = this.localStorage.getItem(this.authTokenFromCookieKey);
        if (authToken === prevAuthToken) {
            return;
        }
        if (!authToken) {
            this.localStorage.removeItem(this.authTokenFromCookieKey);
        } else if (!((_this_getClaims = this.getClaims()) === null || _this_getClaims === void 0 ? void 0 : _this_getClaims.setPasswordOnly)) {
            this.localStorage.setItem(this.authTokenFromCookieKey, authToken);
        }
    }
    didAuthTokenChange(event) {
        var _this_getClaims;
        return event.key === this.authTokenFromCookieKey && event.oldValue !== event.newValue && !((_this_getClaims = this.getClaims()) === null || _this_getClaims === void 0 ? void 0 : _this_getClaims.setPasswordOnly);
    }
    getCookieMap() {
        return document.cookie.split(';').reduce((a, b)=>{
            const [key, val] = b.split('=');
            a[key.trim()] = val;
            return a;
        }, {});
    }
    constructor(authDomain, localStorage, nativeAuthTokenStore, biometric){
        _define_property(this, "authDomain", void 0);
        _define_property(this, "localStorage", void 0);
        _define_property(this, "nativeAuthTokenStore", void 0);
        _define_property(this, "biometric", void 0);
        _define_property(this, "authTokenFromCookieKey", void 0);
        this.authDomain = authDomain;
        this.localStorage = localStorage;
        this.nativeAuthTokenStore = nativeAuthTokenStore;
        this.biometric = biometric;
        this.authTokenFromCookieKey = 'authTokenFromCookie';
    }
}
const noop = ()=>{};
const nullFn = ()=>null;
export const mockCookiesManager = {
    getCookie: ()=>'',
    setCookie: noop,
    setAuthTokenForNative: noop,
    clearAuthToken: noop,
    getCookieByName: nullFn,
    getAuthToken: nullFn,
    getClaims: nullFn,
    trySignalAuthTokenChange: noop,
    didAuthTokenChange: ()=>false,
    getUserEmailFromUserDetailsCookie: nullFn,
    getDecodedCookieByName: nullFn,
    getHasVendorAccountFromUserDetailsCookie: nullFn
};
